import { CheckCircle2 } from "lucide-react";

import { Button } from "@/components/ui/button";

import { brl } from "../lib/formato";

/** Mesa reaberta em Vendas → Pedidos cujos pagamentos da lista já quitam a
 *  conta (reabriu e não mudou nada, ou trocou uma forma por outra de mesmo
 *  valor): fecha de novo sem cobrar — sem lançar venda de R$ 0,00. */
export default function FecharReaberta({ desconto, onFechar, ocupado }) {
  return (
    <div className="mb-3 rounded-lg border border-emerald-300 dark:border-emerald-800 bg-emerald-50 dark:bg-emerald-950/30 p-3 flex items-center gap-3" data-e2e="fechar-reaberta">
      <CheckCircle2 className="w-5 h-5 text-emerald-600 shrink-0" />
      <p className="text-sm flex-1">
        Nada a cobrar: os pagamentos da lista já quitam a conta{desconto > 0 ? ` com o desconto de ${brl(desconto)}` : ""}.
      </p>
      <Button size="sm" onClick={onFechar} disabled={ocupado} data-e2e="fechar-reaberta-botao">Fechar de novo</Button>
    </div>
  );
}
